<script setup lang="ts">
interface Props {
  disabled?: boolean;
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  ariaLabel: 'Переключатель',
});

const modelValue = defineModel<boolean>({ default: false });
</script>

<template>
  <button
    type="button"
    role="switch"
    :aria-checked="modelValue"
    :aria-label="ariaLabel"
    :disabled="disabled"
    class="group inline-flex min-h-11 min-w-11 items-center justify-center rounded-full focus-visible:ring-2 focus-visible:ring-(--accent) focus-visible:ring-offset-2 focus-visible:ring-offset-(--surface-card) focus-visible:outline-none active:scale-[0.96] disabled:cursor-not-allowed disabled:opacity-50"
    @click="modelValue = !modelValue"
  >
    <span
      :class="[
        'relative h-6 w-10 rounded-full border transition-[background-color,border-color] duration-200',
        modelValue ? 'border-(--accent) bg-(--accent)' : 'border-(--field-border) bg-(--field-border)',
      ]"
      aria-hidden="true"
    >
      <span
        :class="[
          'absolute top-0.5 left-0.5 h-[18px] w-[18px] rounded-full bg-(--on-accent) shadow-sm transition-transform duration-200',
          modelValue ? 'translate-x-4' : 'translate-x-0',
        ]"
      />
    </span>
  </button>
</template>
